import { Input } from 'antd';
import React from 'react';

import FieldInputBuffer from '../../components/fieldInputBuffer';
import { IFieldBase } from '../../interfaces';

const FieldWoSi: React.FC<IFieldBase> = ({ disabled }) => {
    return (
        <FieldInputBuffer
            nameField={'woSi'}
            labelField={'WO / SI #'}
            inputComponents={(onChange, valueField) => (
                <Input disabled={disabled} value={valueField} onChange={onChange} />
            )}
        />
    );
};

export default React.memo(FieldWoSi);
